import cn from "classnames";
import { Map as SharedMap } from "components/map/shared";
import { divIcon } from "leaflet";
import React, { useEffect, useRef, useState } from "react";
import { Marker, Polygon, Polyline } from "react-leaflet";
import { useMapEvent } from "react-leaflet/hooks";
import { connect } from "react-redux";

function PolygonPicker(props) {
    const map = useRef();
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            map.current?.fitBounds(props.points);
        }, 300);
        return () => clearTimeout(timeoutId);
    }, []);
    const [viewport, setViewport] = useState({ zoom: 8, center: [55.7473, 52.4568] });
    const addPoint = ({ latlng }) => {
        if (props.isLooped) {
            return;
        }
        props.setPoints([...props.points, [latlng.lat, latlng.lng]]);
    };

    const renderPolylines = () => {
        if (props.points.length < 2) {
            return null;
        }
        return props.points.map((point, i) => {
            if (!props.points[i + 1]) {
                return null;
            }
            return <Polyline key={i} positions={[point, props.points[i + 1]]} />;
        });
    };

    const handleDrag = (target, index) => {
        const { lng, lat } = target._latlng;
        const newPoints = props.points.map((item, i) => (i === index ? [lat, lng] : item));
        props.setPoints(newPoints);
    };

    return (
        <SharedMap ref={map} tileUrls={props.tileUrls} maxZoom={18} viewport={viewport} onViewportChanged={setViewport}>
            {props.points.map((item, index) => {
                const isLastLooped = props.isLooped && [props.points.length - 1, 0].includes(index);
                const icon = divIcon({
                    className: cn("map-icon--unstable-zone-point", {
                        "map-icon--unstable-zone-point-looped": isLastLooped,
                    }),
                    iconSize: [16, 16],
                });
                return (
                    <Marker
                        key={item.join(", ")}
                        draggable={!isLastLooped}
                        position={item}
                        icon={icon}
                        eventHandlers={{
                            click: (event) => {
                                event.originalEvent.view.L.DomEvent.stopPropagation(event);
                                if (index === 0 && props.points.length > 2) {
                                    props.setIsLooped(true);
                                    addPoint({ latlng: { lat: props.points[0][0], lng: props.points[0][1] } });
                                }
                            },
                            dblclick: (event) => {
                                event.originalEvent.view.L.DomEvent.stopPropagation(event);
                                const newPoints = [...props.points];
                                if (index === 0 || index === props.points.length - 1) {
                                    newPoints.pop();
                                    props.setIsLooped(false);
                                } else {
                                    newPoints.splice(index, 1);
                                }

                                props.setPoints(newPoints);
                            },
                            dragend: ({ target }) => handleDrag(target, index),
                        }}
                    />
                );
            })}
            {renderPolylines()}
            {props.isLooped && <Polygon positions={props.points} />}
            <MapClickHandler onClick={addPoint} />
        </SharedMap>
    );
}

const MapClickHandler = (props) => {
    useMapEvent("click", props.onClick);
    return null;
};

const mapStateToProps = (state) => ({
    tileUrls: state.configs.tileUrls,
});

export default connect(mapStateToProps, () => ({}))(PolygonPicker);
